<template>
  <el-aside width="auto" :style="{height: myHeight}">
    <logo />
    <el-menu :style="{height: myHeight}" class="el-menu-vertical-demo" default-active="0" :collapse="!collapse" :default-openeds="defaultOpen" :unique-opened="unOpend">
      <!-- <el-submenu index="null" class="header-title">
        <template slot="title">
          <img class="title-img" src="../assets/logo.svg" />
          <span class="header-title" @click="toIndex">{{$t('menu.title')}}</span>
        </template>
      </el-submenu> -->
       <router-link
          v-if="isShowDashBoard"
          class="router-link"
          :to="{ name: 'dashboard' }"
        >
          <el-menu-item style="text-align: left;">
            <i class="menu-title el-icon-house"></i>
            <span class="menu-title" slot="title">{{$t('login.dashboard')}}</span>
          </el-menu-item>
        </router-link>
      <el-submenu :index="menuIndex.toString()" v-for="(menuInfo, menuIndex) in menuList" :key="menuIndex">
        <template slot="title">
          <i class="menu-icon" :class="menuInfo.icon"></i>
          <span class="menu-title" v-if="currLanguage === 'en'">{{menuInfo.title}}</span>
          <span class="menu-title" v-if="currLanguage === 'zh'">{{menuInfo.chinaTitle}}</span>
        </template>
        <router-link v-for="(detail, detailIndex) in menuInfo.details" :key="detailIndex" class="router-link" :to="{ name: detail.routerName}">
          <el-menu-item :index="menuIndex+'-'+detailIndex" v-if="currLanguage === 'en'">{{detail.name}}</el-menu-item>
          <el-menu-item :index="menuIndex+'-'+detailIndex" v-if="currLanguage === 'zh'">{{detail.chinaName}}</el-menu-item>
        </router-link>
      </el-submenu>
    </el-menu>
    <!-- <div class="menu-direction-div">
      <div :class="menuDirection" class="menu-direction" @click="handleSwitch"></div>
    </div> -->
  </el-aside>
</template>

<script>
import { mapGetters } from 'vuex'
import Logo from './Logo.vue';
export default {
  name: 'MyNavigation',
  components: {
    Logo
  },
  data () {
    return {
      menuList: [],
      isShowDashBoard: false,
      myHeight: window.innerHeight + 'px',
      isCollapse: false,
      unOpend: true, // 是否保持一个子菜单打开
      defaultOpen: [], // 默认打开的菜单（作者展开全部菜单）
      // menuDirection: 'el-icon-d-arrow-left',
      currLanguage: 'en'
    }
  },
  computed: {
    ...mapGetters(['collapse'])
  },
  created: function () {
    this.searchMenu()
    if (window.innerWidth < 481) {
      this.isCollapse = true
      // this.menuDirection = 'el-icon-d-arrow-right'
    }
    //会议id：c,增加首页展示 conferenceId
    if (this.$route.params.co_id === '954') {
      this.isShowDashBoard = true
      this.$router.push({ name: 'dashboard' })
    }
  },
  methods: {
    toIndex () {
      console.log(this.$router)
      this.$router.push({ name: 'paper' })
    },
    searchMenu () {
      this.menuList = JSON.parse(localStorage.getItem('menuData'))
      let user = JSON.parse(localStorage.getItem('user'))
      // 作者登录，默认菜单展开
      if (user.currRole === 'Author') {
        this.unOpend = false
        this.defaultOpen = ['0', '1']
      } else {
        this.unOpend = true
        this.defaultOpen = []
      }
      // 徐鹏   投稿结束
      if (user.submitPaperFlag !== '1') {
        for (let item of this.menuList) {
          if (item.chinaTitle === '论文') {
            for (let index of item.details) {
              if (index.routerName === 'paperEdit') {
                index.routerName = 'paperWhite'
              }
            }
          }
        }
      }
      this.currLanguage = localStorage.getItem('language') || 'en'
    },
    // handleSwitch: function () {
    //   this.isCollapse = !this.isCollapse
    //   if (this.isCollapse) {
    //     this.menuDirection = 'el-icon-d-arrow-right'
    //   } else {
    //     this.menuDirection = 'el-icon-d-arrow-left'
    //   }
    // }
  }
}
</script>

<style scoped>
.el-submenu__title {
  color: #333;
}
  .el-aside {
    color: #fff;
    overflow-y: hidden;
  }
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
    min-height: 400px;
  }
  .el-menu{
    /* width: 200px; */
    -ms-overflow-style:none;
    overflow: scroll;
    text-align: left;
  }
  .el-menu::-webkit-scrollbar{
    display: none;
  }
  /* .header-title{
    text-align: left;
    background-color: #002040;
    width: 100%;
    line-height: 80px;
    height: 80px;
    color: #FFFFFF;
    text-align: center;
    font-weight: bolder;
  }
  .title-img{
    width: 35px;
    margin: 0px;
    padding: 0px;
  } */
  .el-menu {
    background-color: #fff;
    color: #333;
    float: left;
    border: 0px;
  }
  .el-submenu__title {
    background-color: red;
  }
  .menu-icon{
    color: #333;
    font-weight: bolder;
  }
  .menu-title{
    color: #333;
    font-weight: bolder;
  }
  .el-menu-item{
    background-color: #fff;
    color: #595959;
    text-align: center;
  }
  .el-menu-item:hover{
    background-color: #f5e7e7!important;
    color: #950e0a!important;
  }
  .router-link{
    text-decoration: none;
    color: #f0f0f0;
  }
  .el-menu-item:hover .router-link{
    color: #7794A1;
  }
  .el-menu-item.is-active {
    background-color: #f5e7e7!important;
    color: #950e0a!important;
  }
  /*.menu-direction{*/
    /*color: #f5f5f5;*/
    /*width: 100%;*/
    /*line-height: 50px;*/
    /*cursor: pointer;*/
    /*font-size: 20px;*/

  /*}*/
  /*.menu-direction:hover{*/
    /*background-color: #2c3e50;*/
  /*}*/

  /* .menu-direction-div{
    height: 100%;
    width: 10px;
    line-height: 100%;
    display: inline-block;
    vertical-align: middle;
    text-align: center;
    float: left;
    background-color: #031529;
  }
  .menu-direction{
    color: #f5f5f5;
    cursor: pointer;
    font-size: 10px;
    background-color: #1F7A9F;
    padding: 20px 0;
    position: relative;
    top: 50%;
    margin-top: -10px;
  }
  .menu-direction:hover{
    background-color: #2c3e50;
  } */
</style>



// WEBPACK FOOTER //
// src/components/MyNavigation.vue